export default __webpack_public_path__ + "../img/83e2181153251ac29ac78c6001ad17df.png";